/**
 * Ticket WK8: Der eigene Prüfeingang entfällt. Alle Fälle stehen an einer
 * Stelle auf der Wahlkalender-Seite; alte Verweise landen dort.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/admin/wahlkalender_/pruefeingang")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/wahlkalender" });
  },
});
